<template>
  <d-container fluid class="auth main-content-container align-items-center justify-content-center">
    <d-col v-if="!d_showQueryError" cols="12">
      <d-row v-if="d_request.loading && !d_request.error" class="justify-content-center">
        <d-col class="col-auto">
          <loader :loading="d_request.loading" />
        </d-col>
      </d-row>

      <div v-else-if="d_request.error">
        {{ $t('error.general') }}: {{ d_request.errors.get('message') }}
      </div>

      <d-row v-else class="justify-content-center">
        <d-col class="col-12">
          <div v-if="d_showOneTimeLogin" class="d-flex justify-content-center mb-3">
            <button :class="oneTimeLogin ? 'login-bottons' : 'border-bottom'"  class="pt-3 pb-3 navbar-toggler border-top border-left pl-4 pr-4 rounded-0 border-right"  @click="oneTimeLogin=true">  {{ $t('one_time_session.login_with_reference') }}</button>
            <button class="pt-3 pb-3 navbar-toggler border-top border-right pl-4 pr-4 rounded-0" :class="!oneTimeLogin ? 'login-bottons' : 'border-bottom'"  @click="oneTimeLogin=false">{{ $t('one_time_session.I_have_an_account') }}</button>
          </div>
        </d-col>
        <d-col class="border bg-white p-4 my-5 my-xl-0 col-10 col-md-8 col-xl-6"  >
          <d-row class="justify-content-between">
            <d-col v-if="!d_showOneTimeLogin || !oneTimeLogin" class="col-12" >
              <h3 class="border-bottom border-dark pb-2 mb-4">
                {{ $t('login.title') }}
              </h3>

              <auth-login :loginChallenge="d_loginChallenge" />

              <hr />

              <auth-social-login :loginChallenge="d_loginChallenge" />
            </d-col>

            <d-col v-else cols="12" class="auth-one-time-session col-12 mt-3 pt-3 mt-xl-0 pt-xl-0">
          
              <h3 class="border-bottom border-dark pb-2 mb-4">
                {{ $t('one_time_session.login_with_reference') }}
              </h3>

              <auth-one-time-session :loginChallenge="d_loginChallenge" />
            </d-col>
          </d-row>
        </d-col>
      </d-row>
    </d-col>

    <d-col v-else md="8" class="text-center">
      {{ $t('login.invalid_token') }}
    </d-col>
  </d-container>
</template>

<script>
import AuthLogin from '@/components/auth/Login';
import RedirectRequest from '@/library/RedirectRequest';
import AuthSocialLogin from '@/components/auth/SocialLogin';
import AuthOneTimeSession from '@/components/auth/OneTimeSession';

export default {
  name: 'auth-index',
  components: {AuthLogin, AuthOneTimeSession, AuthSocialLogin},
  data () {
    return {
      d_request: new RedirectRequest(),
      d_response: {},
      d_showOneTimeLogin: false,
      d_showQueryError: false,
      d_loginChallenge: null,
      oneTimeLogin: false

    };
  },
  created () {
    if (!(this.$route.query.hasOwnProperty('login_challenge') && this.$route.query.login_challenge)) {
      this.d_showQueryError = true;

      return;
    }

    this.d_loginChallenge = this.$route.query.login_challenge;

    const url = `login?login_challenge=${this.d_loginChallenge}`;

    this.d_request.get(url)
      .then(response => {
        this.d_response = response;

        this.handleResponse();
      });
  },
  methods: {
    handleResponse () {
      if (this.d_response.hasOwnProperty('one_time')) {
        this.d_showOneTimeLogin = this.d_response.one_time;
        this.oneTimeLogin = this.d_response.one_time;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../assets/scss/_variables.scss";
.login-bottons{
border-bottom: 2px solid #05b0f5;
}
.auth-one-time-session {
  border-top: $border-color solid 1px;

  // 1200px is the breakpoint for the XL size
  @media (min-width: 1200px) {
    border-top: none;
 
  }
}
</style>

